import { useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { Lock } from "lucide-react";
import { money } from "@/lib/api";

export function EmbeddedCardStep({ publishableKey, clientSecret, reference, fee }) {
  const stripePromise = useMemo(() => loadStripe(publishableKey), [publishableKey]);
  return (
    <div className="space-y-6 lg:col-span-8" data-testid="embedded-card-step">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
        <div className="mb-2 flex items-center gap-3"><span className="grid h-8 w-8 place-items-center rounded-full bg-emerald-700 text-sm font-bold text-white">✓</span><h2 className="font-display text-xl font-bold text-slate-900">Details received · Reference <span className="font-mono" data-testid="booking-reference">{reference}</span></h2></div>
        <p className="text-sm text-slate-600">Last step: add the card that will hold your trial. Nothing is charged today. The {money(fee)} trial fee is charged only after we confirm your trial.</p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-8">
        <p className="mb-4 flex items-center gap-2 font-display text-lg font-bold text-slate-900"><Lock className="h-5 w-5 text-emerald-700" />Secure card details</p>
        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
        <p className="mt-4 text-xs text-slate-500">Card details are encrypted and processed by our certified payment processor. We never store your full card number or CVV.</p>
      </div>
    </div>
  );
}
